import MenuSelect from '../extensions/MenuSelect'
import { allAudiences } from '../../constants/audiences'

const approvedRefinements = ['All', ...allAudiences]

export default function AudienceFilter() {
  return (
    <MenuSelect
      label='Age'
      icon='user-graduate'
      attribute='audiences'
      transformItems={refinements =>
        refinements.filter(r => approvedRefinements.includes(r.label))
      }
    />
  )
}
